
export type GradingMethod = 'highest-grade' | 'last-attempt'
export type ExamResultRole = 'section' | 'final'
export type AttemptResult = 'passed' | 'failed'

export interface ExamResultState {
  id: string
  attempts: ExamAttempt[]
  effectiveGrading: GradingMethod | 'unknown'
}

export interface ExamAttempt {
  timestamp: Date;
  score: {
    min: number
    max: number
    raw: number
  }
  passingScore: number
  result: AttemptResult
  durationSeconds: number
}

export function defaultExamResultState(id: string): ExamResultState {
  return {
    id,
    attempts: [],
    effectiveGrading: 'unknown'
  }
}
